<template>
  <div>
    <el-dialog
      class="sv_on_support_dialog"
      :visible.sync="$store.state.store_sv.sv_help_onSupport_DiaLogVisible"
      width="30%"
      v-if="$store.state.sysInit.ws_mode != 'MANUAL_CHAT_MODE'"
    >
      <span slot="title" class="dialog-header">
        <span class="sv_title_text">{{
          this.$store.state.store_sv.sv_helper_info.svName
        }}</span>
        <span class="sv_title"> からのSVサポート</span>
      </span>

       <div style="padding: 5px"></div>
      <span class="sv_name"
        >{{ this.$store.state.store_sv.sv_helper_info.svName }} が
        SVサポートに参加しています。</span
      >
      <br />
      <div style="padding: 20px"></div>

      <span class="sv_extension">内線番号 :</span>
      <span id="svExtension" class="sv_extension_text">
        {{ this.$store.state.store_sv.sv_helper_info.svExtension }}</span
      >
      <div style="padding: 30px"></div>
      <div  class="dialog-footer_sv">
          <el-button type="primary" plain @click="svExtensionCopy"
            >内線番号をコピー</el-button
          >
          <!-- <el-button plain disabled>SVサポートを終了</el-button> -->
      </div>
    </el-dialog>

    <el-dialog
      class="sv_on_support_dialog"
      :visible.sync="$store.state.store_sv.sv_help_onSupport_DiaLogVisible"
      width="30%"
      v-if="$store.state.sysInit.ws_mode == 'MANUAL_CHAT_MODE'"
    >
      <span slot="title" class="dialog-header">
        <span class="sv_title_text">
          {{ this.$store.state.store_sv.chat_sv_name }}
        </span>
        <span class="sv_title"> からの SVサポート</span>
      </span>
      <span
        v-for="(menu, index) in this.$store.state.store_sv
          .chat_sv_helper_info_list"
        :key="index"
      >
        <span
          v-if="
            menu.questioner_id == $store.state.sysInit.manualChatQuestionerId
          "
        >
         <div style="padding: 5px"></div>
          <span class="sv_name"
            >{{ menu.svName }} :が SVサポートに参加しています。</span
          >
          <br />
          <div style="padding: 20px"></div>
          <span class="sv_extension">内線番号 :</span>
          <span id="svExtension" class="sv_extension_text">{{
            menu.svExtension
          }}</span>
        </span>
      </span>
<div style="padding: 30px"></div>
<div class="dialog-footer_sv">
  <el-button type="primary" plain @click="svExtensionCopy"
          >内線番号をコピー</el-button
        >
        <!-- <el-button plain disabled>SVサポートを終了</el-button> -->
</div>
        
    </el-dialog>
  </div>
</template>

<script>
const _ = require("lodash");
import { Message } from "element-ui";
export default {
  data() {
    return {};
  },

  methods: {
    closeSvHelperDialog() {
      this.$store.state.store_sv.sv_help_onSupport_DiaLogVisible = false;
    },

    svExtensionCopy() {
      let svExtension_text = document.getElementById("svExtension").innerText;
      let self = this;
      this.$copyText(svExtension_text || "").then(
        function (e) {
          Message.success(
            self.$store.state.sysInit.html_const
              .cons_232_copied_successfully_msg
          );
        },
        function (e) {
          console.log(e);
        }
      );
    },
  },
};
</script>
<style lang="scss">
.sv_title_text {
  color: white;
  padding-right: 2px;
  padding-left: 5px;
  font-size: 14px;
}
.sv_title {
  color: white;
  font-size: 14px;
}

.sv_name {
  padding-left: 25px;
  font-size: 16px;
  font-weight: bold;
}

.sv_extension {
  padding: 25px;
  padding-right: 0px;
  font-size: 16px;
  font-weight: bold;
}
.sv_extension_text {
  font-size: 16px;
  font-weight: bold;
}
.dialog-footer_sv{
    text-align: center;
    box-sizing: border-box;
}
</style>